import { Component, OnInit } from '@angular/core';
import { FrameworkSettings } from '../models/frameworkSettings';
import { PaymentService } from '../services/payment/payment.service';
import { ForuscareService } from '../services/foruscare/foruscare.service';

@Component({
  selector: 'app-framework-settings',
  templateUrl: './framework-settings.component.html',
  styleUrls: ['./framework-settings.component.css']
})
export class FrameworkSettingsComponent implements OnInit {

  paymentGateway:Boolean=false;
  frameworkSettings:FrameworkSettings;
  constructor(public paymentService:PaymentService,public foruscareService:ForuscareService) { }

  ngOnInit() {
    this.frameworkSettings = new FrameworkSettings();
    this.getFrameworkSettings();
    
  }
  save() {
    var requestObj = [];
    this.frameworkSettings.PAYMENT_GATEWAY = (this.paymentGateway == true? "PAYUMONEY": "RAZORPAY");
    for(var t in this.frameworkSettings){
      requestObj.push({"type":t,"value":this.frameworkSettings[t]});
    }
    this.paymentService.saveFrameworkSettingsByApplication(requestObj,"DHP")
      .subscribe(response => {
        if (response.errorCode == 200) {
          this.foruscareService.showNotification("Settings updated", "success");
        }
        else {
          this.foruscareService.showNotification("Something went wrong", "danger");
        }
      })
  }
  getFrameworkSettings(){
    this.paymentService.getFrameworkSettingsByApplication("DHP")
    .subscribe(response=>{
      if(response.errorCode = 200 && response.data!=null){
        response.data.forEach(element => {
          this.frameworkSettings[element.type] = element.value;
          if(element.type=="PAYMENT_GATEWAY"){
            this.paymentGateway = element.value=="PAYUMONEY"?true:false;
          }
        });
      }
      else{
        this.foruscareService.showNotification("No data found", "danger");
      }
    })
  }

}
